import { RESPONSIVE_PADDING } from 'constants/ui';

export const filterBarStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: `0 ${RESPONSIVE_PADDING.MOBILE}`,
};

export const filterRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  flexWrap: 'wrap',
};

export const filterLabelStyles = {
  color: ({ palette }) => palette.text.placeholder,
  minWidth: '42px',
  flexShrink: 0,
};
